import { ColProps, Form } from 'antd';
import { Rule } from 'antd/lib/form';
import classNames from 'classnames';
import { FC, memo, ReactNode } from 'react';

import './style.scss';

interface IProps {
    label?: ReactNode;
    name?: string;
    colon?: boolean;
    extra?: ReactNode;
    initialValue?: string;
    labelAlign?: 'left' | 'right';
    required?: boolean;
    isText?: boolean;
    tooltip?: ReactNode;
    rules?: Rule[];
    validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating' | undefined;
    help?: ReactNode | string | undefined | any;
    children?: ReactNode;
    className?: string;
    hasFeedback?: boolean;
    isExplain?: boolean;
    labelCol?: ColProps;
}

const FormItemWrap: FC<IProps> = ({
    label,
    name,
    colon = false,
    extra,
    initialValue,
    labelAlign,
    required,
    tooltip,
    rules,
    validateStatus,
    children,
    className,
    hasFeedback,
    help,
    isExplain = true,
    isText = false,
    labelCol,
}) => {
    return (
        <Form.Item
            label={label}
            name={name}
            colon={colon}
            extra={extra}
            initialValue={initialValue}
            labelAlign={labelAlign}
            required={required}
            tooltip={tooltip}
            rules={rules}
            hasFeedback={hasFeedback}
            validateStatus={validateStatus}
            help={help || ''}
            className={classNames('form__item__wrap', className, { 'is-explain': isExplain, 'is-text': isText })}
            labelCol={labelCol}
        >
            {children}
        </Form.Item>
    );
};

export default memo(FormItemWrap);
